<template>
  <section class="ct-copy-blocks">
    <div class="ct-copy-blocks__container container">
      <div class="content-type__content">
        <div
          v-if="slice?.Settings?.Title"
          class="ct-copy-blocks__heading content-type__heading heading heading--2"
        >
          {{ slice.Settings.Title }}
        </div>

        <p
          v-if="slice?.Settings?.Description"
          class="content-type__description"
        >
          {{ slice.Settings.Description }}
        </p>

        <div
          v-if="slice?.Copy?.Richtexts?.length"
          class="ct-copy-blocks__grid"
        >
          <div
            v-for="data in slice.Copy.Richtexts"
            :key="data"
            class="ct-copy-blocks__richtext"
            :style="`color: ${data.Color || 'inherit'}`"
          >
            <StrapiBlocksText
              :nodes="data.Richtext"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
  context: {
    type: [Object, Array],
    default: () => null,
  },
})
</script>

<style src="~layers/app/components/Slices/CopyBlocks.css" />
